import React from 'react';

const Card = ({children, title, wrapperClass, headerClass, bodyClass, headerClick, titleClass, onScroll, ref }) => {
    return (
        <div className={"card bg-white rounded-lg border-gray-100 shadow text-gray-700 " + (wrapperClass ?? "")}>
            {
                title &&
                <div className={"card-heading bg-gray-200 px-4 py-2 rounded-t-lg border-b border-gray-400 "   + (headerClass ?? "")}>
                    <h3 className={"font-medium " + (titleClass ?? "")} onClick={headerClick}>{title}</h3>
                </div>
            }

            <div className={"card-body p-5 "  + (bodyClass ?? "")} onScroll={onScroll} ref={ref}>
                {children}
            </div>
        </div>
    );
};

export default Card;